(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.promotionHeroSlider = {
        attach: function (context) {
            const slider = once('lays_nlng_ca-hero-slider', '.promotion-banner__slider .swiper', context)[0];
            if (!slider) return;

            if (typeof Swiper === 'undefined') {
                console.warn('Swiper library not loaded');
                return;
            }

            // Helper: stop all videos and remove their ended listeners
            const stopAllVideos = () => {
                slider.querySelectorAll('video').forEach(video => {
                    video.pause();
                    video.removeEventListener('ended', video._onEnded);
                    video._onEnded = null;
                });
            };

            // Helper: play video in active slide from the beginning
            const handleActiveSlide = (swiper) => {
                const activeSlide = slider.querySelector('.swiper-slide-active');
                if (!activeSlide) return;

                const video = activeSlide.querySelector('video');
                if (video) {
                    // Stop autoplay while video plays
                    swiper.autoplay.stop();

                    // Always start from beginning
                    video.currentTime = 0;

                    // When video ends, advance to next slide and resume autoplay
                    video._onEnded = () => {
                        video.removeEventListener('ended', video._onEnded);
                        video._onEnded = null;
                        swiper.slideNext();
                        swiper.autoplay.start();
                    };
                    video.addEventListener('ended', video._onEnded);

                    // Play the video
                    video.play().catch(err => {
                        console.warn('Video autoplay failed:', err);
                        // If video fails to play, resume autoplay after 5s
                        setTimeout(() => {
                            swiper.slideNext();
                            swiper.autoplay.start();
                        }, 5000);
                    });
                } else {
                    // No video on this slide, use normal 5s autoplay
                    swiper.autoplay.start();
                }
            };

            const options = {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true,
                centeredSlides: false,
                effect: 'slide',
                speed: 1000,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.promotion-banner__slider .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.promotion-banner__slider .swiper-button-next',
                    prevEl: '.promotion-banner__slider .swiper-button-prev',
                },
                on: {
                    slideChange: function () {
                        stopAllVideos();
                    },
                    slideChangeTransitionEnd: function (swiper) {
                        handleActiveSlide(swiper);
                    },
                    init: function (swiper) {
                        // Stop autoplay initially, we'll start it after handling video
                        swiper.autoplay.stop();
                        // Delay to ensure DOM is ready and active class is applied
                        setTimeout(() => {
                            handleActiveSlide(swiper);
                        }, 100);
                    }
                }
            };

            try {
                new Swiper(slider, options);
                slider.classList.add('is-swiper-active');
            } catch (error) {
                console.error('Failed to initialize Swiper:', error);
            }
        }
    };

})(Drupal, once);